'use client';

import { useUserWishlist } from '@/shared/providers/user-provider/use-user';
import type { MiniBannerCounterProps } from './types';

export const WishlistCounter = ({ renderCounter }: MiniBannerCounterProps) => {
  const wishlist = useUserWishlist();
  const count = wishlist?.length;

  if (count == null || !renderCounter) return null;

  return renderCounter(count.toString());
};
